<template>
  <form-item v-bind="$attrs" v-on="$listeners" class-name="BrandModel">
    <brand-select class="fullwidth" v-model="model[$attrs.prop]"></brand-select>
  </form-item>
</template>

<script>
  import FormItem from '@/components/form/FormItem'
  import BrandSelect from '@/components/selector/BrandSelect'

  export default {
    name: 'BrandModelFormItem',
    components: {
      BrandSelect,
      FormItem
    },
    computed: {
      model () {
        let parent = this.$parent
        while (parent) {
          if (parent.model != null) return parent.model
          parent = parent.$parent
        }
        return null
      }
    }
  }
</script>
